import React, { useState } from 'react'
import { Form, Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useLoginMutation } from '../store/api'
import GlobalToast from '../components/GlobalToast'

const LoginPage: React.FC = () => {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [login, { isLoading }] = useLoginMutation()
	const navigate = useNavigate()

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()

		try {
			await login({ email, password }).unwrap()
			navigate('/invoices')
		} catch (error) {
			console.error(error)
		}
	}

	return (
		<>
			<div className="d-flex justify-content-center align-items-center min-vh-100">
				<div className="card" style={{ width: '400px' }}>
					<div className="card-body">
						<h3 className="card-title text-center mb-4">Вхід в систему</h3>

						<Form onSubmit={handleSubmit}>
							<Form.Group className="mb-3">
								<Form.Label>Email</Form.Label>
								<Form.Control
									type="email"
									placeholder="Введіть email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
									disabled={isLoading}
								/>
							</Form.Group>

							<Form.Group className="mb-3">
								<Form.Label>Пароль</Form.Label>
								<Form.Control
									type="password"
									placeholder="Введіть пароль"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
									required
									disabled={isLoading}
								/>
							</Form.Group>

							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={isLoading}
							>
								{isLoading ? (
									<>
										<Spinner
											as="span"
											animation="border"
											size="sm"
											role="status"
											aria-hidden="true"
											className="me-2"
										/>
										Вхід...
									</>
								) : (
									'Увійти'
								)}
							</Button>
						</Form>
					</div>
				</div>
			</div>
			<GlobalToast />
		</>
	)
}

export default LoginPage
